import { AlertTriangle, CheckCircle2, Loader2, RotateCcw } from "lucide-react";

const money = (cents = 0) => new Intl.NumberFormat("en-US", {
  style: "currency", currency: "USD",
}).format(Number(cents));

export const AuctionDisputesTab = ({ disputes, resolving, onResolve }) => (
  <div className="space-y-5">
    <div>
      <h2 className="text-2xl text-[#EDEDED]">Auction Disputes</h2>
      <p className="text-sm text-[#A1A1AA] mt-1">
        Review protected payments before refunding the buyer or releasing the seller payout.
      </p>
    </div>

    {!disputes.length ? (
      <div className="rounded-xl border border-white/10 bg-white/5 p-10 text-center text-[#71717A]">
        <CheckCircle2 className="w-8 h-8 mx-auto mb-3 text-[#22C55E]" />
        No open auction disputes.
      </div>
    ) : disputes.map((item) => (
      <article key={item.auction_id} className="rounded-xl border border-red-500/30 bg-red-500/5 p-5">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-red-300">
              <AlertTriangle className="w-5 h-5" />
              <h3 className="font-medium">Auction {item.auction_id}</h3>
            </div>
            <p className="text-sm text-[#A1A1AA] mt-2">{item.dispute_reason || "No reason supplied"}</p>
            <p className="text-xs text-[#71717A] mt-1">
              Opened {item.dispute_opened_at ? new Date(item.dispute_opened_at).toLocaleString() : "date unavailable"}
            </p>
          </div>
          <div className="grid grid-cols-3 gap-4 text-sm">
            <div><p className="text-[#71717A]">Winning bid</p><p className="text-[#EDEDED]">{money(item.winning_bid)}</p></div>
            <div><p className="text-[#71717A]">Buyer total</p><p className="text-[#EDEDED]">{money(item.buyer_total)}</p></div>
            <div><p className="text-[#71717A]">Seller payout</p><p className="text-[#EDEDED]">{money(item.seller_payout_amount)}</p></div>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 mt-5">
          <button
            disabled={!!resolving}
            onClick={() => window.confirm("Refund the buyer? This cannot be undone in Stripe.") && onResolve(item.auction_id, "refund_buyer")}
            className="inline-flex items-center gap-2 rounded-full border border-red-500/50 px-4 py-2 text-sm text-red-300 disabled:opacity-50"
          >
            {resolving === item.auction_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <RotateCcw className="w-4 h-4" />}
            Refund Buyer
          </button>
          <button
            disabled={!!resolving}
            onClick={() => window.confirm("Resolve for the seller and release the protected payout?") && onResolve(item.auction_id, "release_seller")}
            className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-4 py-2 text-sm text-black disabled:opacity-50"
          >
            {resolving === item.auction_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
            Release Seller Payout
          </button>
        </div>
      </article>
    ))}
  </div>
);
